import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { history } from "../store";

import MachineStatusBadge from "./MachineStatusBadge";
import MachineCashBadge from "./MachineCashBadge";
import { getMachineCash, getMachineCashColor } from "../utils/machines";
import {
  addUniversalUpdateSingleParameters,
  addUniversalUpdateSingleReboot,
} from "../actions/universalupdates";

class MachineList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parametersConfirmShown: false,
      rebootConfirmShown: false,
      machineId: null,
      filters: {
        serial: "",
        customer: "",
        status: "",
        biller: "",
        pay: "",
      },
      // Local input values for immediate UI feedback
      inputValues: {
        serial: "",
        customer: "",
      },
      showButton: false,
      buttonPosition: { x: 0, y: 0 },
      selectedMachineId: null,
      filteredMachines: [], // Cache filtered results
      displayLimit: 100, // Initially show only 100 machines
      showAll: false, // Flag to show all machines
    };

    this.updateParameters = this.updateParameters.bind(this);
    this.rebootMachine = this.rebootMachine.bind(this);

    this.parametersConfirmShow = this.parametersConfirmShow.bind(this);
    this.parametersConfirmToggle = this.parametersConfirmToggle.bind(this);
    this.rebootConfirmShow = this.rebootConfirmShow.bind(this);
    this.rebootConfirmToggle = this.rebootConfirmToggle.bind(this);

    this.handleRightClick = this.handleRightClick.bind(this);
    this.debounceTimer = null;
  }

  componentDidMount() {
    // Initialize filtered machines
    this.updateFilteredMachines();
  }

  componentDidUpdate(prevProps, prevState) {
    // Re-filter when machines change or filters change
    if (
      prevProps.machines !== this.props.machines ||
      prevState.filters !== this.state.filters
    ) {
      this.updateFilteredMachines();
      // Reset to limited view when filters change
      if (prevState.filters !== this.state.filters) {
        this.setState({ showAll: false });
      }
    }
  }

  componentWillUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  updateFilteredMachines() {
    const filteredMachines = this.getFilteredMachines();
    this.setState({ filteredMachines });
  }

  goTo(id, e) {
    history.push(`/machines/${id}`);
  }

  handleRightClick(e, machineId) {
    e.preventDefault(); // Prevent the default context menu

    const elementRect = e.target.getBoundingClientRect();

    this.setState({
      showButton: true,
      buttonPosition: {
        x: elementRect.left + window.scrollX, // Adjust to account for scrolling
        y: elementRect.top + window.scrollY, // Adjust to account for scrolling
      },
      selectedMachineId: machineId,
    });
  }

  hideButton = () => {
    this.setState({ showButton: false, selectedMachineId: null });
  };

  handleButtonClick = () => {
    const { selectedMachineId } = this.state;
    if (selectedMachineId) {
      window.open(`/machines/${selectedMachineId}`, "_blank"); // Open in a new tab
      this.hideButton(); // Hide the button after clicking
    }
  };

  handleFilterChange(filterKey, value) {
    // Update immediately for dropdowns (status, biller, pay)
    if (filterKey === 'status' || filterKey === 'biller' || filterKey === 'pay') {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          [filterKey]: value,
        },
      }));
    } else {
      // For text inputs: update local input value immediately for UI feedback
      this.setState((prevState) => ({
        inputValues: {
          ...prevState.inputValues,
          [filterKey]: value,
        },
      }));

      // Debounce the actual filter state update by 400ms
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      this.debounceTimer = setTimeout(() => {
        this.setState((prevState) => ({
          filters: {
            ...prevState.filters,
            [filterKey]: value,
          },
        }));
      }, 400);
    }
  }

  clearFilters = () => {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.setState({
      filters: {
        serial: "",
        customer: "",
        status: "",
        biller: "",
        pay: "",
      },
      inputValues: {
        serial: "",
        customer: "",
      },
    });
  };

  getPayments(tipo) {
    switch (tipo) {
      case 0: {
        return "TPV + CASH";
      }
      case 1: {
        return "CASH";
      }
      case 2: {
        return "TPV";
      }
      case 3: {
        return "RFID";
      }
      case 4: {
        return "GRATIS";
      }
    }
  }

  renderLanguages(language, languages) {
    // Ensure both arguments are valid
    const safeLang = typeof language === "string" ? language : "es_ES";
    const list = Array.isArray(languages) ? languages : [];

    const languageImages = list.map((lang, i) => {
      const languageCode = (lang?.Language || "es_ES").split("_")[0];
      return (
        <div className="col" key={i}>
          <img
            className="machinelistlanguage"
            src={`/languages/${languageCode.toLowerCase()}.png`}
            alt={lang?.Language || "es_ES"}
          />
        </div>
      );
    });

    const mainLanguageCode = safeLang.split("_")[0];

    return (
      <div className="row">
        <div className="col mb-3 p-3 border-bottom border-info">
          Base:{" "}
          <img
            className="machinelistlanguage"
            src={`/languages/${mainLanguageCode.toLowerCase()}.png`}
            alt={safeLang}
          />
        </div>
        {languageImages}
      </div>
    );
  }

  handleParametersClick = (machine, event) => {
    event.stopPropagation();
    if (
      machine.Status !== "OPERATIVE" &&
      machine.Status !== "LOCKERS_FULL" &&
      machine.Status !== "SLEEP"
    ) {
      alert("Acción bloqueada! La máquina no está online.");
    } else {
      this.parametersConfirmShow(machine._id);
    }
  };

  updateParameters() {
    const { addUniversalUpdateSingleParameters } = this.props;

    addUniversalUpdateSingleParameters(this.state.machineId);
    this.parametersConfirmToggle();
  }

  parametersConfirmShow(id) {
    this.setState({
      parametersConfirmShown: true,
      machineId: id,
    });
  }

  parametersConfirmToggle() {
    this.setState({
      parametersConfirmShown: !this.state.parametersConfirmShown,
    });
  }

  handleRebootClick = (machine, event) => {
    event.stopPropagation();
    if (
      machine.Status !== "OPERATIVE" &&
      machine.Status !== "LOCKERS_FULL" &&
      machine.Status !== "SLEEP"
    ) {
      alert("Acción bloqueada! La máquina no está online.");
    } else {
      this.rebootConfirmShow(machine._id);
    }
  };

  rebootMachine() {
    const { addUniversalUpdateSingleReboot } = this.props;

    addUniversalUpdateSingleReboot(this.state.machineId);
    this.rebootConfirmToggle();
  }

  rebootConfirmShow(id) {
    this.setState({
      rebootConfirmShown: true,
      machineId: id,
    });
  }

  rebootConfirmToggle() {
    this.setState({ rebootConfirmShown: !this.state.rebootConfirmShown });
  }

  formatNightscanDate = (timestamp) => {
    if (!timestamp || typeof timestamp !== "string" || timestamp.length < 14) {
      return null;
    }

    const year = timestamp.substring(0, 4);
    const month = parseInt(timestamp.substring(4, 6), 10) - 1;
    const day = parseInt(timestamp.substring(6, 8), 10);
    const hour = parseInt(timestamp.substring(8, 10), 10);
    const minute = parseInt(timestamp.substring(10, 12), 10);
    const second = parseInt(timestamp.substring(12, 14), 10);

    return new Date(year, month, day, hour, minute, second);
  };

  isNightscanInSleepPeriod = (nightscanDate, sleepStart, sleepEnd) => {
    if (
      !nightscanDate ||
      !(nightscanDate instanceof Date) ||
      isNaN(nightscanDate)
    ) {
      return false;
    }

    const now = new Date();
    const today = new Date(now);
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    // Check if nightscanDate is from today or yesterday
    const isTodayOrYesterday =
      nightscanDate.toDateString() === today.toDateString() ||
      nightscanDate.toDateString() === yesterday.toDateString();

    if (!isTodayOrYesterday) return false;

    const startHours = Math.floor(sleepStart / 100);
    const startMinutes = sleepStart % 100;
    const endHours = Math.floor(sleepEnd / 100);
    const endMinutes = sleepEnd % 100;

    let startDate = new Date(nightscanDate);
    startDate.setHours(startHours, startMinutes, 0, 0);

    let endDate = new Date(nightscanDate);
    endDate.setHours(endHours, endMinutes, 0, 0);

    // If sleepStart is greater than sleepEnd, it means the sleep spans across midnight
    if (
      startHours > endHours ||
      (startHours === endHours && startMinutes > endMinutes)
    ) {
      // Adjust the dates to span midnight
      if (nightscanDate.toDateString() === yesterday.toDateString()) {
        // The nightscanDate is from yesterday, so we set the startDate as yesterday's date
        startDate = new Date(yesterday);
        startDate.setHours(startHours, startMinutes, 0, 0);

        // The endDate will be today at the sleepEnd time
        endDate = new Date(today);
        endDate.setHours(endHours, endMinutes, 0, 0);
      } else if (nightscanDate.toDateString() === today.toDateString()) {
        // The nightscanDate is from today, we need to check if it’s within the end range
        const previousDayStartDate = new Date(yesterday);
        previousDayStartDate.setHours(startHours, startMinutes, 0, 0);

        // End date remains as today's sleepEnd
        return (
          nightscanDate >= previousDayStartDate && nightscanDate <= endDate
        );
      }
    }

    // Normal case where sleepStart is less than or equal to sleepEnd (no midnight spanning)
    return nightscanDate >= startDate && nightscanDate <= endDate;
  };

  getZoneName(zone) {
    switch (zone) {
      case 0:
        return "GENERAL";
      case 1:
        return "BAQUEIRA";
      case 2:
        return "BERET";
      case 3:
        return "BONAIGUA";
      case 4:
        return "RUDA";
      case 5:
        return "BOSQUE";
      case 6:
        return "BOSQUE-CONSIGNAS";
      default:
        return "NONE";
    }
  }

  getUpdaterStatus(lastUpdaterSignal) {
    if (!lastUpdaterSignal) return "🟢"; // Default to red if no signal

    const lastSignalDate = new Date(lastUpdaterSignal);
    const now = new Date();
    const diffInMinutes = (now - lastSignalDate) / (1000 * 60);

    return diffInMinutes > 60 ? "🟢" : "🟢";
  }

  getFilteredMachines() {
    const { filters } = this.state;
    const { machines, category } = this.props;
    const { serial, customer, status, biller, pay } = filters;

    return machines.filter((machine) => {
      // Apply the Serial filter
      if (
        serial &&
        !machine.Serial.toLowerCase().includes(serial.trim().toLowerCase())
      ) {
        return false;
      }

      // Apply the Customer or Contract Zone filter based on category
      if (customer) {
        if (category === "BAQUEIRA") {
          // Apply the Contract Zone filter
          if (
            !machine.Contract ||
            !machine.Contract.Zone ||
            !this.getZoneName(machine.Contract.Zone)
              .toLowerCase()
              .includes(customer.toLowerCase())
          ) {
            return false;
          }
        } else {
          // Apply the Customer filter
          if (
            !machine.Customer ||
            !machine.Customer.Fullname.toLowerCase().includes(
              customer.toLowerCase()
            )
          ) {
            return false;
          }
        }
      }

      // Apply the Status filter
      if (
        status &&
        (!machine.Status ||
          !machine.Status.toLowerCase().includes(status.toLowerCase()))
      ) {
        return false;
      }

      // Apply the Biller filter
      if (
        biller &&
        !getMachineCash(machine).toLowerCase().includes(biller.toLowerCase())
      ) {
        return false;
      }

      // Apply the Pay filter
      if (pay && machine.PaymentMethods !== parseInt(pay, 10)) {
        return false;
      }

      // If all conditions pass, include the machine in the filtered list
      return true;
    });
  }

  render() {
    const { inputValues, filteredMachines } = this.state;
    const { filters } = this.state;
    const { machines, auth, role, category, type } = this.props;

    if (!machines) {
      return <div></div>;
    }

    return (
      <div>
        {/* Filter Panel - Outside the table */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-md-3 mb-2">
                <label htmlFor="filter-serial" className="form-label small text-muted mb-1">
                  Identificador
                </label>
                <input
                  id="filter-serial"
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar por serial..."
                  value={inputValues.serial}
                  onChange={(e) =>
                    this.handleFilterChange("serial", e.target.value)
                  }
                />
              </div>
              <div className="col-md-3 mb-2">
                <label htmlFor="filter-customer" className="form-label small text-muted mb-1">
                  {category === "BAQUEIRA" ? "Zona" : "Cliente"}
                </label>
                <input
                  id="filter-customer"
                  type="text"
                  className="form-control form-control-sm"
                  placeholder={`Buscar por ${category === "BAQUEIRA" ? "zona" : "cliente"}...`}
                  value={inputValues.customer}
                  onChange={(e) =>
                    this.handleFilterChange("customer", e.target.value)
                  }
                />
              </div>
              <div className="col-md-2 mb-2">
                <label htmlFor="filter-status" className="form-label small text-muted mb-1">
                  Estado
                </label>
                <select
                  id="filter-status"
                  className="form-control form-control-sm"
                  value={filters.status}
                  onChange={(e) =>
                    this.handleFilterChange("status", e.target.value)
                  }
                >
                  <option value="">Todos</option>
                  <option value="OPERATIVE">ONLINE</option>
                  <option value="OFFLINE">OFFLINE</option>
                  <option value="SLEEP">SLEEP</option>
                  <option value="NIGHT_SCAN">NIGHTSCAN</option>
                  <option value="MAINTENANCE">MANTENIMIENTO</option>
                  <option value="LOCKERS_FULL">LOCKERS LLENOS</option>
                  <option value="TICKET_EMPTY">SIN TICKET</option>
                  <option value="KERONG_OTA">OTA KERONG</option>
                  <option value="BOOTLOADER_OTA">OTA BOOTLOADER</option>
                  <option value="BLE_OFF">POWER DOWN</option>
                </select>
              </div>
              {category !== "BAQUEIRA" && (
                <>
                  <div className="col-md-2 mb-2">
                    <label htmlFor="filter-pay" className="form-label small text-muted mb-1">
                      Tipo de Pago
                    </label>
                    <select
                      id="filter-pay"
                      className="form-control form-control-sm"
                      value={filters.pay}
                      onChange={(e) =>
                        this.handleFilterChange("pay", e.target.value)
                      }
                    >
                      <option value="">Todos</option>
                      <option value="0">TPV + CASH</option>
                      <option value="1">CASH</option>
                      <option value="2">TPV</option>
                      <option value="3">RFID</option>
                      <option value="4">GRATIS</option>
                    </select>
                  </div>
                  <div className="col-md-2 mb-2">
                    <label htmlFor="filter-biller" className="form-label small text-muted mb-1">
                      Billetero
                    </label>
                    <select
                      id="filter-biller"
                      className="form-control form-control-sm"
                      value={filters.biller}
                      onChange={(e) =>
                        this.handleFilterChange("biller", e.target.value)
                      }
                    >
                      <option value="">Todos</option>
                      <option value="OK">OK</option>
                      <option value="FULL">FULL</option>
                    </select>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Table without filters */}
        <div className="table-responsive">
          <table className="table table-hover table-clickable">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Identificador</th>
                <th scope="col">{category == "BAQUEIRA" ? "Zona" : "Cliente"}</th>
                <th scope="col">Estado</th>
                {category !== "BAQUEIRA" && <th scope="col">Idiomas</th>}
                <th scope="col">Passwords</th>
                {role === "ADMIN" && (
                  <th scope="col">Versiones</th>
                )}
                {category !== "BAQUEIRA" && <th scope="col">Pagos</th>}
                {role === "ADMIN" && (
                  <th scope="col">Nightscan</th>
                )}
                <th scope="col">PC</th>
                {role === "ADMIN" && (
                  <th scope="col">Acciones</th>
                )}
              </tr>
            </thead>
          <tbody>
            {filteredMachines.length > 0 && (
              <>
                {(this.state.showAll 
                  ? filteredMachines 
                  : filteredMachines.slice(0, this.state.displayLimit)
                ).map((machine) => {
              // Create a new Date object using the parsed parts
              const nightscanDate = this.formatNightscanDate(
                machine.NightScanTimeStampEnd
              );

              const isInSleepPeriod = this.isNightscanInSleepPeriod(
                nightscanDate,
                machine.SleepStart,
                machine.SleepEnd
              );
              const cellClass = isInSleepPeriod
                ? "bg-success text-white rounded"
                : "bg-danger text-white rounded";

              return (
                <tr
                  key={machine._id}
                  onClick={(e) => this.goTo(machine._id, e)}
                  onContextMenu={(e) => this.handleRightClick(e, machine._id)}
                >
                  <th scope="row">
                    {machine.Serial}
                    <br />
                    {`${machine.FirstIndex} a ${
                      parseInt(machine.LastIndex) +
                      parseInt(machine.FirstIndex) -
                      1
                    }`}
                    <br />({machine.LastIndex} Taquillas)
                  </th>
                  <td className="notranslate">
                    {machine.Customer ? (
                      category === "BAQUEIRA" ? (
                        this.getZoneName(machine.Contract.Zone)
                      ) : (
                        <>
                          {machine.Customer.Fullname}
                          <br />
                          {(() => {
                            const zoneObj = machine.Customer.Zones?.find(
                              (z) => z.Zone === machine.Contract.Zone
                            );
                            return zoneObj
                              ? `Zona ${zoneObj.Zone} - ${zoneObj.Description}`
                              : `Zona ${machine.Contract.Zone}`;
                          })()}
                          <br />
                          {machine.QRActive && (
                            <div className="d-flex justify-content-center align-items-center">
                              <i
                                className="fa fa-qrcode mr-1"
                                aria-hidden="true"
                              ></i>
                              {machine.QRPercentage}%
                            </div>
                          )}
                        </>
                      )
                    ) : (
                      "None"
                    )}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <MachineStatusBadge machine={machine} />
                    <br></br>
                    {machine.Last_signal
                      ? new Date(machine.Last_signal).toLocaleString()
                      : "—"}
                    <br></br>
                    Sleep:{" "}
                    {`${machine?.SleepStart?.substring(
                      0,
                      2
                    )}:${machine?.SleepStart?.substring(2)} h`}{" "}
                    -{" "}
                    {`${machine?.SleepEnd?.substring(
                      0,
                      2
                    )}:${machine?.SleepEnd?.substring(2)} h`}
                    <br></br>
                    Updater:{" "}
                    <span>
                      {this.getUpdaterStatus(machine.Last_updater_signal)}
                    </span>
                  </td>
                  {category !== "BAQUEIRA" && (
                    <td style={{ whiteSpace: "nowrap" }}>
                      {machine?.SupportedLanguages
                        ? this.renderLanguages(
                            machine.Language,
                            machine.SupportedLanguages
                          )
                        : "—"}
                    </td>
                  )}
                  <td style={{ whiteSpace: "nowrap" }}>
                    {category !== "BAQUEIRA" && (
                      <>
                        <i className="fas fa-cogs mr-1 text-muted"></i>
                        Maquina: {machine.PasswordMachine}
                        <br />
                      </>
                    )}
                    {category !== "BAQUEIRA" && (
                      <>
                        <i className="fas fa-money-bill-wave mr-1 text-success"></i>
                        Cash: {machine.PasswordFund}
                        <br />
                      </>
                    )}
                    {type !== "CASH" && (
                      <>
                        <i className="fas fa-lock mr-1 text-primary"></i>
                        Universal: {machine.PasswordCash}
                        <br />
                      </>
                    )}
                    {role === "ADMIN" && (
                      <>
                        <i className="fas fa-user-shield mr-1 text-warning"></i>
                        Master: {machine.PasswordMaster}
                        <br />
                      </>
                    )}
                    {role === "ADMIN" && (
                      <>
                        <i className="fas fa-clipboard-list mr-1 text-info"></i>
                        QC: {machine.PasswordQC}
                      </>
                    )}
                  </td>
                  {role === "ADMIN" && (
                    <td>
                      SW: {machine.Sw_version}
                      <br></br>
                      FW: {machine.Fw_version}
                      <br></br>
                      UP: {machine.Up_version}
                      <br></br>
                      ESP32: <br></br>
                      {machine.ESP32_version}
                      <br></br>
                    </td>
                  )}
                  {category !== "BAQUEIRA" && (
                    <td>
                      {this.getPayments(machine.PaymentMethods)}
                      <br></br>
                      {(machine.PaymentMethods == 0 ||
                        machine.PaymentMethods == 1) && (
                        <div className="d-inline-block p-2">
                          <MachineCashBadge machine={machine} />
                        </div>
                      )}
                    </td>
                  )}
                  {role === "ADMIN" && (
                    <td>
                      <div className={`d-inline-block p-2 ${cellClass}`}>
                        {nightscanDate ? nightscanDate.toLocaleString() : "—"}
                      </div>
                    </td>
                  )}
                  <td>
                    {machine.CoreTemp}
                    <br></br>
                    {machine.Anydesk}
                    <br></br>
                    {machine.IP}
                    <br></br>
                    {role === "ADMIN" &&
                      (machine.OS === 2 ? (
                        <div className="row justify-content-center align-items-center">
                          <i className="fa-brands fa-ubuntu mr-1"></i>
                          <span>Ubuntu</span>
                        </div>
                      ) : (
                        <div className="row justify-content-center align-items-center">
                          <i className="fa-brands fa-raspberry-pi mr-1"></i>
                          <span>Raspbian</span>
                        </div>
                      ))}
                  </td>
                  {role === "ADMIN" && (
                    <td>
                      <button
                        className="btn btn-vw mb-3"
                        onClick={(event) =>
                          this.handleParametersClick(machine, event)
                        }
                      >
                        <i className="fas fa-database"></i>
                        <span className="d-none d-sm-inline ml-1">
                          Actualizar
                        </span>
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={(event) =>
                          this.handleRebootClick(machine, event)
                        }
                      >
                        <i className="fas fa-plug"></i>
                        <span className="d-none d-sm-inline ml-1">
                          Reiniciar
                        </span>
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
            </>
            )}
          </tbody>
        </table>
        
        {/* Show "Load More" button if there are more machines to display */}
        {!this.state.showAll && filteredMachines.length > this.state.displayLimit && (
          <div className="text-center my-3">
            <div className="alert alert-info d-inline-block">
              Mostrando {this.state.displayLimit} de {filteredMachines.length} máquinas
            </div>
            <br />
            <Button
              color="primary"
              onClick={() => this.setState({ showAll: true })}
            >
              <i className="fas fa-chevron-down mr-2"></i>
              Mostrar todas ({filteredMachines.length})
            </Button>
          </div>
        )}
        
        {/* Show summary when all are displayed */}
        {this.state.showAll && filteredMachines.length > this.state.displayLimit && (
          <div className="text-center my-3">
            <div className="alert alert-success d-inline-block">
              Mostrando todas las {filteredMachines.length} máquinas
            </div>
          </div>
        )}
        </div>
        
        <div>
          <Modal
            isOpen={this.state.parametersConfirmShown}
            toggle={this.parametersConfirmToggle}
          >
            <ModalHeader toggle={this.parametersConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de actualizar los parámetros?</p>
              <br></br>
              <p>
                -La máquina se actualizará interrumpiendo los procesos y saldrá
                un mensaje en pantalla para reiniciar la máquina una vez
                finalizado el proceso.
              </p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.updateParameters}>
                Actualizar
              </Button>
              <Button color="secondary" onClick={this.parametersConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        <div>
          <Modal
            isOpen={this.state.rebootConfirmShown}
            toggle={this.rebootConfirmToggle}
          >
            <ModalHeader toggle={this.rebootConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de reiniciar la máquina?</p>
              <br></br>
              <p>-La máquina se reiniciará interrumpiendo los procesos.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.rebootMachine}>
                Reiniciar
              </Button>
              <Button color="secondary" onClick={this.rebootConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        {this.state.showButton && (
          <div
            style={{
              position: "absolute",
              top: `${this.state.buttonPosition.y}px`,
              left: `${this.state.buttonPosition.x}px`,
              zIndex: 1000,
            }}
          >
            <Button
              color="primary"
              className={`btn-baqueira`}
              onClick={() => {
                this.handleButtonClick(); // Handle blocked locker logic
              }}
            >
              <i className="fas fa-door-open d-block ml-auto mr-auto mb-2"></i>
              Abrir en pestaña nueva
            </Button>
            <Button
              color="secondary"
              className={`btn-baqueira`}
              onClick={() => {
                this.hideButton(); // Hide button after action
              }}
            >
              <i className="fas fa-times d-block ml-auto mr-auto mb-2"></i>
              Cancelar
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  category: state.auth.category,
});

const mapDispatchToProps = (dispatch) => ({
  addUniversalUpdateSingleParameters: bindActionCreators(
    addUniversalUpdateSingleParameters,
    dispatch
  ),
  addUniversalUpdateSingleReboot: bindActionCreators(
    addUniversalUpdateSingleReboot,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineList);
